/**
 * ROWIE — recently viewed tracker
 *
 * Records the current product handle with a timestamp. Kept separate
 * from the carousel so tracking still happens on pages that don't
 * render the carousel at all.
 */

(function () {
  const KEY = 'rowie:recently-viewed';
  const MAX = 20; // stored; the carousel shows fewer
  const MAX_AGE_DAYS = 30;

  function read() {
    try {
      const raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      // Private browsing or full quota — tracking is non-essential.
    }
  }

  function prune(list) {
    const cutoff = Date.now() - MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
    return list.filter(function (entry) {
      return entry && entry.handle && entry.at > cutoff;
    });
  }

  window.RowieRecentlyViewed = {
    get: function () {
      return prune(read()).map(function (e) {
        return e.handle;
      });
    },

    record: function (handle) {
      if (!handle) return;
      let list = prune(read());
      // Drop any existing entry so a re-visit moves to the front.
      list = list.filter(function (e) {
        return e.handle !== handle;
      });
      list.unshift({ handle: handle, at: Date.now() });
      write(list.slice(0, MAX));
    },
  };

  const el = document.querySelector('[data-rowie-track-product]');
  if (el) {
    window.RowieRecentlyViewed.record(el.dataset.rowieTrackProduct);
  }
})();